function CallLogExpandCellRenderer() { }

CallLogExpandCellRenderer.prototype.init = function initCallLogExpandCellRenderer(params) {
  this.eGui = document.createElement('span');
  
  let expanded = this.componentContext.expandedDetailRowNodes[params.node?.id];

  let iconClass = expanded ? DETAIL_EXPANDED_ICON_CLASS : DETAIL_CONTRACTED_ICON_CLASS;
  let groupExpandClass = expanded ? DETAIL_EXPANDED_CLASS : DETAIL_CONTRACTED_CLASS;

  this.eGui.innerHTML = `<span
      title="${params.node?.data?.callStatus?.tooltip ? params.callConnectionStatusTooltips[params.node?.data?.callStatus?.tooltip] : ''}"
      class="mark-call__status ${params.node?.data?.callStatus?.cssClass}"
      tag="div"
    >
    </span>

    <span
      class="ag-icon ${iconClass} group-expand-cell ${groupExpandClass} clickable m-r-3"
    >
    </span>

    ${params.valueFormatted}`;
};

CallLogExpandCellRenderer.prototype.getGui = function() {
  return this.eGui;
};

export default CallLogExpandCellRenderer;
export function getCallLogExpandRendererComponent(componentContext) {
  CallLogExpandCellRenderer.prototype.componentContext = componentContext;
  return CallLogExpandCellRenderer;
}

export const DETAIL_CONTRACTED_CLASS = 'group-expand-cell--contracted';
export const DETAIL_EXPANDED_CLASS = 'group-expand-cell--expanded';
export const DETAIL_CONTRACTED_ICON_CLASS = 'ag-icon-small-down';
export const DETAIL_EXPANDED_ICON_CLASS = 'ag-icon-small-up';